
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
    FaHome,
    FaUsers,
    FaHashtag,
    FaBuilding
} from 'react-icons/fa';
import styles from '../styles/LeftSidebar.module.css';

export default function LeftSidebar() {
    const { currentUser: user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const navItems = [
        { icon: <FaHome />, label: 'Home', path: '/feed' },
        { icon: <FaHashtag />, label: 'Explore', path: '/clubs' },
        { icon: <FaUsers />, label: 'Groups', path: '/groups' },
        // Profile and Settings moved to Navbar Dropdown
    ];

    if (!user) return null;

    return (
        <aside className={styles.container}>
            <div className={styles.stickyContent}>


                {/* Navigation */}
                <nav className={styles.nav}>
                    {navItems.map((item) => (
                        <button
                            key={item.path}
                            className={`${styles.navItem} ${location.pathname === item.path ? styles.active : ''}`}
                            onClick={() => navigate(item.path)}
                        >
                            <span className={styles.icon}>{item.icon}</span>
                            <span className={styles.label}>{item.label}</span>
                        </button>
                    ))}
                    {/* Branch Quick Link */}
                    <div className={styles.branchSection}>
                        {/* Logic to get branch from email would go here, hardcoded for visual layout */}
                        <button className={styles.branchBtn} onClick={() => navigate('/branch/CSE')}>
                            <FaBuilding />
                            <span>My Branch</span>
                        </button>
                    </div>
                </nav>
            </div>
        </aside>
    );
}
